import { Patient } from "../models/patient";
import { API_PREFIX } from "./constant";
import { Request } from "./request";

export interface GetPatientListParams {
  current?: number;
  size?: number;
  param?: string;
  labelName?: string;
}

export function getPatientList(params: GetPatientListParams): Request {
  return {
    url: `${API_PREFIX}/blade-outpatient/patient/list`,
    method: "GET",
    params,
  };
}

export function getPatientDetail(patientId: string): Request {
  return {
    url: `${API_PREFIX}/blade-outpatient/patient/detail`,
    method: "GET",
    params: {
      id: patientId,
    },
  };
}

export interface SavePatientParams {
  patient: Patient;
  registrationId?: string;
  treatmentId?: string;
}

export function savePatient(params: SavePatientParams): Request {
  return {
    url: `${API_PREFIX}/blade-outpatient/patient/save`,
    method: "POST",
    body: params,
  };
}
